import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Dialog, DialogTitle, DialogContent } from '../Dialog';
import { Button } from '../Button';
import ratingOrder from '../../../constants/ratingOrder';
import WriteReviewStore from '../../../store/WriteReviewStore';
import  WriteReview  from '../../Generic/WriteReview/writeReviewForm';
import styles from './readreview-tw-styles';
import Typography from '../Typography/Typography';

export class ReviewFilter extends React.Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    productData: PropTypes.oneOfType([PropTypes.object]),
    pageContext: PropTypes.oneOfType([PropTypes.object]),
  };

  static defaultProps = {
    productData: null,
    pageContext: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isPreviewMode: false,
    };
  }

  handlePreviewChange = (isPreview) => {
    this.setState({ isPreviewMode: isPreview });
  };

  handleClick = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false, isPreviewMode: false });
  };
  render() {
    const { locale, productData, pageContext } = this.props;
    const { open, isPreviewMode } = this.state;
    WriteReviewStore.locale = pageContext.locale;
    const constants = require(`../../../constants/messages/${locale}`);
    return (
      <div className={styles.reviewfilter.wrapper}>
        <div className={styles.reviewfilter.filterFlex}>
          <div className={styles.reviewfilter.writeReviewLinkText}>
            <Button
              data-pgaction-redirection="0"
              onClick={this.handleClick}
              title={constants.writeReview}
              data-action-detail="product-review"
              className={classNames(
                styles.reviewfilter.writereviewlink,
                'event_product_review'
              )}
            >
              <Typography
                component="span"
                className={styles.reviewfilter.writeReviewLinkSpan}
              >
                <FormattedMessage
                  id="writeReview"
                  defaultMessage={constants.writeReview}
                />
              </Typography>
              <Typography component="span" className={styles.reviewIconRite} />
            </Button>
            <Dialog
              open={open}
              onClose={this.handleClose}
              className=""
              modalStyle={styles.logOutDialogue}
              backdropStyle={styles.backDropStyles}
            >
              <DialogTitle
                className={styles.reviewDialogueTitle}
                component="div"
              >
                {!isPreviewMode && (
                  <Button
                    className={classNames(
                      styles.reviewCloseBtn,
                      'event_cancel_review'
                    )}
                    aria-label='Fechar janela pop-up.'
                    onClick={this.handleClose}
                    data-action-detail="cancel-review"
                  >
                    <span className={styles.reviewCloseSpan}>×</span>
                  </Button>
                )}
              </DialogTitle>
              <DialogContent className={styles.reviewDialogueContent} />
               <WriteReview
                productData={pageContext.productData}
                locale={pageContext.locale}
                prodID={productData.ratingAndReviewId}
                onSubmit={WriteReviewStore.onSubmit}
                onChange={WriteReviewStore.onChange}
                validateField={WriteReviewStore.validateField}
                form={WriteReviewStore.previewForm}
                onCancel={WriteReviewStore.onCancel}
                ratingOrder={ratingOrder}
                onPreviewChange={this.handlePreviewChange}
              /> 
            </Dialog>
          </div>
        </div>
      </div>
    );
  }
}

export default ReviewFilter;
